import { useMutation, useQueryClient } from "react-query";
import ToggleButton from "../../components/common/ToggleButton";
import { findLecture, registLecture } from "../../api";
import { useMount, useUpdateEffect } from "react-use";
import { useState } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import Icon from "../../components/common/Icon";

const LectureFindPage = ({ student_id }) => {
  const queryClient = useQueryClient();
  const [list, setList] = useState([]);
  const [filter, setFilter] = useState({ coming: false, ing: false });

  const { mutate: onRegist } = useMutation({
    mutationFn: registLecture,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lecture/find"] });
    },
    onSettled: async (data, error) => {
      const { result } = data;
      let status = "success";
      let message = "";
      if (result) {
        status = data.data.status;
        message = data.data.message;
        getListQuery();
      }
      if (error) {
        status = error.status;
        message = error.message;
      }
      if (message) {
        toast.custom((t) => (
          <div
            className={`alert w-11/12 sm:w-1/2 md:w-1/4 bg-white border border-zinc-100 text-bold ${
              t.visible ? "animate-enter" : "animate-leave"
            }
            }`}
          >
            <div>
              <Icon
                name="information-circle"
                className={`text-${status} w-10 h-10`}
              />
              <span className="text-sm">{message}</span>
            </div>
          </div>
        ));
      }
    },
  });

  const getListQuery = async () => {
    console.log("getListQuery");
    const obj = { ...filter, student_id };
    const result = await queryClient.fetchQuery(
      ["lecture/find"],
      {
        queryFn: () => findLecture(obj),
      },
      { cacheTime: 0, staleTime: 0 }
    );
    if (result.result) {
      const { data } = result;
      setList(data);
    }
  };

  const handleFilter = (e) => {
    const { id, checked } = e.target;
    setFilter({ ...filter, [id]: checked });
  };

  const handleRegist = (lecture_id) => () => {
    onRegist({ lecture_id, student_id });
  };

  useUpdateEffect(() => {
    getListQuery();
  }, [filter]);

  useMount(() => {
    getListQuery();
  });

  return (
    <div className="w-full mx-auto md:w-11/12 md:px-2">
      <h1 className="flex items-center px-2 py-4 font-sans text-xl font-bold break-normal text-cyan-500 md:text-2xl">
        강의 목록
      </h1>
      <div className="flex flex-wrap gap-4">
        {/* <div className="inline-flex items-center">
          <label className="inline-block mx-2 text-sm font-bold label">
            대상
          </label>
          <div className="inline-flex gap-2">
            <ToggleButton {...{ label: "초등", id: "target_100" }} />
            <ToggleButton {...{ label: "중등", id: "target_200" }} />
            <ToggleButton {...{ label: "고등", id: "target_300" }} />
            <ToggleButton {...{ label: "특수", id: "target_99" }} />
          </div>
        </div> */}
        <div className="inline-flex items-center">
          <label className="inline-block mx-2 text-sm font-bold label">
            상태
          </label>
          <div className="inline-flex gap-2">
            <ToggleButton
              {...{ label: "진행전", id: "coming", onChange: handleFilter }}
            />
            <ToggleButton
              {...{ label: "진행중", id: "ing", onChange: handleFilter }}
            />
          </div>
        </div>
      </div>
      <div className="my-4 hero bg-base-100 place-items-stretch">
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
          {list &&
            list.map(
              ({
                _id: id,
                start_date,
                end_date,
                host,
                place,
                title,
                coming,
                ing,
                isRegistered,
              }) => (
                <div className="bg-white shadow card" key={id}>
                  <div className="card-body">
                    <div>
                      <h2 className="justify-between gap-3 card-title">
                        {title}
                        {coming && (
                          <div className="mt-1 text-white badge badge-info place-self-start">
                            진행전
                          </div>
                        )}
                        {ing && (
                          <div className="mt-1 badge badge-accent place-self-start">
                            진행중
                          </div>
                        )}
                      </h2>
                      <div className="flex flex-col mt-2 text-sm">
                        <div className="inline-flex items-baseline gap-1">
                          <span className="flex-none w-16 text-sm font-bold text-end">
                            수업일시:
                          </span>
                          <span>
                            {`${new moment(start_date).format(
                              "YYYY.MM.DD ddd LT"
                            )} ~ ${new moment(end_date).format(
                              "YYYY.MM.DD ddd LT"
                            )}`}
                          </span>
                        </div>
                        <div className="inline-flex items-baseline gap-1">
                          <span className="flex-none w-16 text-sm font-bold text-end">
                            장소:
                          </span>
                          <span>{place}</span>
                        </div>
                        <div className="inline-flex items-baseline gap-1">
                          <span className="flex-none w-16 text-sm font-bold text-end">
                            주최:
                          </span>
                          <span>{host}</span>
                        </div>
                      </div>
                    </div>
                    <div className="justify-end card-actions">
                      <button
                        className={`btn btn-primary btn-sm w-1/3${
                          isRegistered ? " btn-outline" : ""
                        }`}
                        onClick={isRegistered ? undefined : handleRegist(id)}
                      >
                        {isRegistered ? "수강중" : "신청"}
                      </button>
                    </div>
                  </div>
                </div>
              )
            )}
        </div>
      </div>
    </div>
  );
};

export default LectureFindPage;
